module.exports = __webpack_public_path__ + "static/media/SHIPPINGICON-01.22a7d766.svg";